import { render } from "./Default.vue?vue&type=template&id=15032c1c"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"
script.render = render

export default script